import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from 'react'
import algoliasearch from 'algoliasearch'
import { debounce, get, throttle } from 'lodash'

export const FacetsContext = createContext({})

export const useFacets = () => {
  return useContext(FacetsContext)
}

export const FacetsProvider = ({ children }) => {
  const [facets, setFacets] = useState({})
  const [loading, setLoading] = useState(false)
  const state = useMemo(
    () => ({
      facets,
      loading,
      setFacets,
      setLoading,
    }),
    [facets, loading]
  )
  return (
    <FacetsContext.Provider value={state}>{children}</FacetsContext.Provider>
  )
}

export const algoliaClient = algoliasearch(
  'ISOJ21OIEK',
  '5ce3a86240b219c3d6163a6c3ad19008'
)

const songIndex = algoliaClient.initIndex(`song`)
const songAscIndex = algoliaClient.initIndex(`song_name_asc`)
const songDescIndex = algoliaClient.initIndex(`song_name_desc`)

const INDEX_TYPES = {
  song: songIndex,
  songAsc: songAscIndex,
  songDesc: songDescIndex,
}

export const useSearchIndex = ({
  type,
  query,
  facetFilters,
  filters,
  page,
  raw = false,
  hitsPerPage = 10,
}) => {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const { setFacets, setLoading: setLoadingFacets } = useContext(FacetsContext)

  const doSearch = useCallback(
    (forced) => {
      if (!type) return

      setLoading(true)
      setLoadingFacets(true)

      const index = INDEX_TYPES[type]
      index
        .search(query, {
          filters,
          facetFilters,
          page,
          facets: ['*'],
          hitsPerPage,
        })
        .then((result) => {
          setLoading(false)
          setLoadingFacets(false)
          const { nbPages, facets, hits, page } = result

          if (facets) {
            setFacets(facets)
          }
          const nextState = raw ? result : hits
          setData({ results: nextState, nbPages, page })
        })
    },
    [type, facetFilters, filters, query, page]
  )
  const throttledSearch = useMemo(() => debounce((fn) => fn(), 500), [])

  useEffect(() => {
    throttledSearch(doSearch)
  }, [doSearch])

  return {
    loading,
    ...data,
  }
}
